import { render } from "./StoreDepartmentMapping.vue?vue&type=template&id=4749be0d&scoped=true"
import script from "./StoreDepartmentMapping.vue?vue&type=script&lang=js"
export * from "./StoreDepartmentMapping.vue?vue&type=script&lang=js"

import "./StoreDepartmentMapping.vue?vue&type=style&index=0&id=4749be0d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4749be0d"]])

export default __exports__